import { useDebounce } from "base/src/utils/hooks/useDebounce";
import { useEffect, useState } from "react";
import DepositoContainer from "../../containers/deposito/depositoContainer";

interface PaymentState {
  valueForAPI: string;
  valueForPayment: number;
  selectedCard: string | null;
  selectedTransacaoTipo: string | null;
  selectedPagamento: string | null;
  selectedParcela: number;
  carteiraId: number;
  isCalculating: boolean; 
}

interface CalcularImpostoRequest {
  Valor: number;
  TransacaoTipo: string | null;
  Parcelas: number;
}

function usePayment (depositoContainer: DepositoContainer, carteiraId: number) {
  const [paymentState, setPaymentState] = useState<PaymentState>({
    valueForAPI: "",
    valueForPayment: 0,
    selectedCard: null,
    selectedTransacaoTipo: null,
    selectedPagamento: null,
    selectedParcela: 1,
    carteiraId,
    isCalculating: false,
  });
  

  const debouncedValue = useDebounce(paymentState.valueForAPI, 500);
  useEffect(() => {
    if (debouncedValue !== "") {
      setPaymentState(prevState => ({
        ...prevState,
        isCalculating: true // Set to true before calculation
      }));
      const request: CalcularImpostoRequest = {
        Valor: Number(debouncedValue),
        TransacaoTipo: paymentState.selectedTransacaoTipo,
        Parcelas: paymentState.selectedParcela,
      };

      depositoContainer.CalcularImposto(request, paymentState.carteiraId);
      // setPaymentState(prevState => ({
      //   ...prevState,
      //   valueForPayment: depositoContainer.props.impostos[0].ValorFinal
      // }));
      
    }
  }, [debouncedValue, paymentState.selectedTransacaoTipo, paymentState.selectedParcela]);


  useEffect(() => {
    if (depositoContainer.props.impostos && depositoContainer.props.impostos.length > 0)
      setPaymentState(prevState => ({
        ...prevState,
        valueForAPI: debouncedValue,
        valueForPayment: depositoContainer.props.impostos[0].ValorFinal,
        isCalculating: false,
      }));
      

  }, [depositoContainer.props.impostos]);


  function handleValueChange(value: string) {
    setPaymentState((prevState) => ({ 
      ...prevState,
      valueForAPI: value,
      valueForPayment: depositoContainer.props.impostos[0].ValorFinal,
      isCalculating: true
    }));
  }

  function handleSelect(value: string, name: string, transacaoTipo: string) : void {
    setPaymentState((prevState) => ({
      ...prevState,
      selectedCard: value,
      valueForAPI: debouncedValue,
      selectedPagamento: name,
      selectedTransacaoTipo: transacaoTipo,
      valueForPayment: depositoContainer.props.impostos[0].ValorFinal,
      isCalculating: depositoContainer.props.impostos && depositoContainer.props.impostos.length > 0
        ? false
        : true,
    }));
  }

  function handleParcelasUpdate (parcelas: string) {
    setPaymentState((prevState) => ({ ...prevState, selectedParcela: Number(parcelas), isCalculating: true }));
  }

  return {
    paymentState,
    handleValueChange,
    handleSelect,
    handleParcelasUpdate,
  };
}

export default usePayment;